/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Tap Full screen and the ruler is pinned to the long edge of your screen — vertical in portrait, horizontal in landscape — so you can lay an object against the edge and read its size.`)
};

const es_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Toca Pantalla completa y la regla se fija al lado largo de tu pantalla — vertical en modo retrato, horizontal en apaisado — para que puedas apoyar un objeto contra el borde y leer su tamaño.`)
};

const de_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Tippe auf Vollbild, und das Lineal wird an der langen Kante deines Bildschirms ausgerichtet — vertikal im Hochformat, horizontal im Querformat —, sodass du einen Gegenstand an die Kante legen und seine Größe ablesen kannst.`)
};

const nl_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Tik op Volledig scherm en de liniaal wordt vastgezet aan de lange rand van je scherm — verticaal staand, horizontaal liggend — zodat je een object tegen de rand kunt leggen en de maat kunt aflezen.`)
};

const fr_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Touchez Plein écran et la règle se fixe sur le grand côté de votre écran — vertical en portrait, horizontal en paysage — pour que vous puissiez poser un objet contre le bord et lire sa taille.`)
};

const it_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Tocca Schermo intero e il righello si fissa al lato lungo dello schermo — verticale in modalità ritratto, orizzontale in modalità orizzontale — così puoi appoggiare un oggetto al bordo e leggerne la misura.`)
};

const pt_br2_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Toque em Tela cheia e a régua fica fixada na borda maior da tela — vertical na orientação retrato, horizontal na paisagem — assim você pode encostar um objeto na borda e ler o tamanho.`)
};

const pt_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Toque em Ecrã inteiro e a régua fica fixada à extremidade longa do ecrã — vertical em retrato, horizontal em paisagem — para poder encostar um objeto e ler o tamanho.`)
};

const ja_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。「全画面表示」をタップすると、定規が画面の長辺に固定されます — 縦向きでは垂直、横向きでは水平になります。物を端に当ててサイズを読み取れます。`)
};

const zh_ruler_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。点击“全屏”后，标尺会固定在屏幕长边——竖屏时为纵向，横屏时为横向——这样你就可以将物体贴在边缘读取尺寸。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_faq_a4", locale)
	if (locale === "en") return en_ruler_faq_a4(inputs)
	if (locale === "es") return es_ruler_faq_a4(inputs)
	if (locale === "de") return de_ruler_faq_a4(inputs)
	if (locale === "nl") return nl_ruler_faq_a4(inputs)
	if (locale === "fr") return fr_ruler_faq_a4(inputs)
	if (locale === "it") return it_ruler_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_faq_a4(inputs)
	if (locale === "pt") return pt_ruler_faq_a4(inputs)
	if (locale === "ja") return ja_ruler_faq_a4(inputs)
	return zh_ruler_faq_a4(inputs)
};